import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { t } from "i18next";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import PagePermBits from "../../../../helpers/constants/PagePermBits";
import "./commit-button.css";

function CommitButton() {
  const navigate = useNavigate();
  const showCommit = useSelector(state => state.show_commit);
  const userPermission = useSelector(state => state.user_permission);

  const toCommitButton = () => {
    navigate(RouteUrls.commit);
  }

  return (
    <>
      {showCommit && (userPermission & PagePermBits.commit) ?
        <Chip icon={<UploadFile />}
              label={t("commit.commit")}
              color="warning"
              clickable
              sx={{ direction: 'ltr' }}
              className="commit-button"
              onClick={toCommitButton}
        />
        : null
      }
    </>
  );
}

export default CommitButton;
